if($('.articles-swiper').length){
  hp.swipers = hp.swipers || {};
  
  var articles_swiper = {
    initialized: false
  };
  articles_swiper.init = function(){
    var ArticlesModuleProps = {
      pagination: {
        el: '.article-module-pagination-textSlider',
        // type: 'progressbar',
        type: 'fraction',
        clickable: true,        
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' +'0'+ (index + 1) + '</span>';
        },
      },
      navigation: {
        nextEl: '.right-arrow-video3',
        prevEl: '.left-arrow-video3',
      },
      lazy: false,
      slidesPerView: 3.6,
      spaceBetween: 20,
      loop: true,
      loopAdditionalSlides: 3,
      breakpoints: {
        1224: {
          slidesPerView: 3.4,
          spaceBetween: 20
        },
        1124: {
          slidesPerView: 3.2,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 4.5,
          spaceBetween: 16
        },
        900: {
          slidesPerView: 3.5,
          spaceBetween: 16
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 16
        }
      }
    }
    var ArticlesModuleMethods = {
      resizeHandler: true,
      a11ySwiper: true
    }
    $(document).on('click', '.articles-tile', function(){
      var h2 = $(".articles-hidden-info h2", this).text();
      var p = $(".articles-hidden-info p", this).text();
      var cta = $(".articles-hidden-info .product-cta-anchor .product-cta", this).text() || null;
      var cta_link = $(".articles-hidden-info .product-cta-anchor", this).attr("href") || null;

      if($(window).width() > 1020){
        var img = $(".image-holding-div img", this).data("attr-desktop");
      }else if($(window).width() <= 1020 && $(window).width() >= 900){
        var img = $(".image-holding-div img", this).data("attr-tablet-lg");
      }else if($(window).width() >= 768){
        var img = $(".image-holding-div img", this).data("attr-tablet-sm");
      }else{
        var img = $(".image-holding-div img", this).data("attr-mobile");
      }
      showArticle(h2, p, cta, cta_link, img, $(this).parents('.tile-col-articles'));  
    });

    articles_swiper.instances = hp.swiperInstance('.articles-swiper', ArticlesModuleProps, ArticlesModuleMethods);
    articles_swiper.initialized = true;
  }//init END

  function showArticle(h2, p, cta, cta_link, img, component){
    $(".article-img-holder img", component).attr('src', img);
    $(".article-info h2", component).text(h2);
    $(".article-info p", component).text(p);
    if(cta !== null){
      if($(".article-info a", component).length > 0){
        $(".article-info a .product-cta", component).text(cta);
        $(".article-info a", component).attr("href", cta_link);
      }else{
        $(".article-info", component).append('<a class="product-cta-anchor" href="'+cta_link+'"><div class="product-cta color_00">'+cta+'</div></a>')
      }
    }else{
      $(".article-info a", component).remove();  
    }
  }

  hp.swipers.articles_swiper=articles_swiper;
}
